<mat-toolbar class="flex items-center header">
    <span class="text-3xl mr-4">PricePlanAdmin</span>

    <a 
        class="px-4" 
        mat-button 
        [routerLink]="'/usageRates'" 
        [routerLinkActive]="'selected-route'"
        [routerLinkActiveOptions]="{exact: false}">
        Grilles de vente
    </a>

    <a 
        class="px-4" 
        mat-button 
        [routerLink]="'/packages'" 
        [routerLinkActive]="'selected-route'"
        [routerLinkActiveOptions]="{exact: false}">
        Forfaits
    </a>

    <a 
        class="px-4" 
        mat-button 
        [routerLink]="'/countries'" 
        [routerLinkActive]="'selected-route'"
        [routerLinkActiveOptions]="{exact: true}">
        Pays
    </a>

    <a 
        class="px-4" 
        mat-button 
        [routerLink]="'/zones'" 
        [routerLinkActive]="'selected-route'"
        [routerLinkActiveOptions]="{exact: true}">
        Zones
    </a>

    <a 
        class="px-4" 
        mat-button 
        [routerLink]="'/areas'" 
        [routerLinkActive]="'selected-route'"
        [routerLinkActiveOptions]="{exact: true}">
        Areas
    </a>

    <a 
        class="px-4" 
        mat-button 
        [routerLink]="'/services'" 
        [routerLinkActive]="'selected-route'"
        [routerLinkActiveOptions]="{exact: true}">
        Services
    </a>
</mat-toolbar>